import { Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from './utilities';

/**
 * @summary Handles AI Assistant entry point click on SRP banner
 */
export async function aiAssistantEntryPointClick({ data = {}, state = {}, dataLayer }, option) {
    const {
        placement = 'srp-banner',
        url,
        listingId,
    } = data;

    const inventory = isVDP(dataLayer) && listingId ? getInventoryOwnerById(state, listingId) : undefined;

    // Pixall Analytics
    await Pixall.sendClickEvent({
        eventSource: 'personalization',
        eventType: 'click',
        label: 'text-link::try-our-new-AI-shopping-assistant',
        url,
        placement,
        inventory,
    }, dataLayer, option);
}
